var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{style:({ width: _vm.width }),attrs:{"options":_vm.items,"props":{
    label: 'name',
    value: 'id'
  },"change-on-select":false,"clearable":_vm.clearable,"disabled":_vm.disabled,"placeholder":"请选择","size":_vm.size,"popper-class":"cascader-tag-style"},on:{"change":_vm.onChange},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }